import { render, staticRenderFns } from "./work-assign-dialog.vue?vue&type=template&id=c8e84794&scoped=true"
import script from "./work-assign-dialog.vue?vue&type=script&lang=js"
export * from "./work-assign-dialog.vue?vue&type=script&lang=js"
import style0 from "./work-assign-dialog.vue?vue&type=style&index=0&id=c8e84794&prod&lang=less"
import style1 from "./work-assign-dialog.vue?vue&type=style&index=1&id=c8e84794&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e84794",
  null
  
)

export default component.exports